
import CartDiscountProductCard from "~/components/common/CartDiscountProductCard.vue";

export default {
  name: "CartDiscountProducts",
  components: {
    CartDiscountProductCard,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    statisticItemListName() {
      return this.getItemListName("Shopping Cart", this.title);
    },
    statisticItemListId() {
      return "cart-discount";
    },
  },
  methods: {
    getItemListName(prefix, suffix) {
      return suffix ? `${prefix} - ${suffix}` : prefix;
    },
    handleProductAdded() {
      this.$emit("product-added");
    },
    handleProductDeleted() {
      this.$emit("product-deleted");
    },
  },
};
